<template>
  <AsyncPage
    :loader="useRepairDetailLoader"
    :page-component="RepairDetail"
  />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useRepairDetailLoader } from "./RepairDetail.loader.ts";
import { repair_detail as strings } from "./RepairDetail.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

const loader = useRepairDetailLoader();

useAsyncPageDocumentTitle(
  strings.documentTitle,
  computed(() => loader.repairQuery.data.value?.repair.id),
);

const RepairDetail = defineAsyncComponent(
  () => import("./RepairDetail.vue"),
);
</script>
